<template>
    <div style="margin-top: 0.25rem; font-size: 12px;">
        {{ text }}
    </div>
</template>

<script>

export default {
    name: 'ak-approval-status-select',
    props: {
        text: {
            type: String
        },
    }
}
</script>
